export default __webpack_public_path__ + "static/media/cf.c2b4d408.svg";